import classNames from "classnames";
import React, { Fragment, ReactNode } from "react";
import { ListGroup } from "react-bootstrap";
import { OrderCategory, TApiOrderDetails } from "../../../../api/endpoints/Order";
import { TApiServiceCharge } from "../../../../api/endpoints/ServiceCharge";
import { TApiServicePackage } from "../../../../api/endpoints/ServicePackage";
import { TApiVolumeBand } from "../../../../api/endpoints/VolumeBand";
import InformationCost from "../../../../containers/Order/OrderCostSummary/OrderCostSummaryV2/InformationCost";
import ServiceChargeCost from "../../../../containers/Order/OrderCostSummary/OrderCostSummaryV2/ServiceChargeCost";
import { totalCost } from "../../../../utils/Cost";
import { formatBinaryCapacityUnit, formatCurrency, formatVolumeBand } from "../../../../utils/Format";
import Col from "../../../Common/Col";
import Row from "../../../Common/Row";

interface Props {
  order: TApiOrderDetails;
  serviceCharge?: TApiServiceCharge;
  servicePackage?: TApiServicePackage;
  volumeBand?: TApiVolumeBand;
}

const ListItemContent = (props: { label: string, value: ReactNode; highlight?: boolean }) => {
  const { label, value, highlight = false } = props;
  return (
    <ListGroup.Item className={classNames("order-cost-preview-item", highlight && "highlight")}>
      <span>{label}</span>
      <span>{value}</span>
    </ListGroup.Item>
  )
}

const OrderCostPreview = (props: Props) => {
  const { order, serviceCharge, servicePackage, volumeBand } = props;

  const orderCost = order.cost;
  const orderTotalCost = serviceCharge && order.cost.version !== 'v1' ?
    serviceCharge?.charge_in_eur * 0.01
    : totalCost(orderCost);

  return (
    <div className="order-cost-preview">
      {
        (order.category === OrderCategory.REALTIME || order.category === OrderCategory.EU_CUTOUT) &&
        <Fragment>
          <h3>Order preview</h3>

          <ListGroup variant="flush" className="margin-bottom-md">
            {
              <ListItemContent
                label="Data volume"
                value={
                  `${formatBinaryCapacityUnit((order.cost).data.total_cost!.average_daily_volume)} daily`
                }
              />
            }

            {
              servicePackage &&
              <ListItemContent label="Service Package" value={servicePackage.title} />
            }

            {
              volumeBand &&
              <ListItemContent label="Volume Band" value={`${formatVolumeBand(volumeBand)} per day`} />
            }
          </ListGroup>
        </Fragment>
      }

      <h3>Cost</h3>
      <ListGroup variant="flush" className="margin-bottom-md">
        {
          orderCost.version !== 'v1' && orderCost.version !== 'v6' &&
          <Fragment>
            <InformationCost
              cost={orderCost}
              orderCategory={order.category}
              orderStatus={order.status}
              component={ListItemContent}
            />

            <ServiceChargeCost
              cost={orderCost}
              orderCategory={order.category}
              orderStatus={order.status}
              preview
              component={ListItemContent}
            />
          </Fragment>
        }

        <ListItemContent label="Total annual cost" value={formatCurrency(orderTotalCost)} highlight />
      </ListGroup>

      <div className="margin-bottom-md" style={{ textAlign: 'right' }}>
        Please check all the details of your order before submitting it.
      </div>
    </div>
  )
}

export default OrderCostPreview;
